import React from 'react'
import { Row, Col } from 'antd'
import style from './style.module.scss'

class Report extends React.Component {
  formatAbsoluteValue = (value) => {
    let finalValue
    if (value > 0) {
      finalValue = `+${value.toFixed(1)}`
    } else {
      finalValue = value.toFixed(1)
    }
    return finalValue
  }

  formatPercentValue = (value) => {
    let finalValue
    if (value > 0) {
      finalValue = `+${Math.round(value)}`
    } else {
      finalValue = Math.round(value.toFixed(1))
    }
    return finalValue
  }

  render() {
    const { userClinic, floor, chunkedArray, reportDate, fullwidthClass } = this.props
    return (
      <div style={{ height: '0px', overflow: 'hidden' }}>
        {chunkedArray.length > 0 &&
          chunkedArray.map((arr, index) => (
            <div
              className={`${style.printableDiv} ${fullwidthClass}`}
              id={`printableDiv_page${index}`}
            >
              <Row
                className={` ${style.headerDiv} ${fullwidthClass}`}
                id={`headerDiv_page${index}`}
              >
                <Row>
                  <Col span={20} id={`headerTitle_page${index}`}>
                    {userClinic.name} {floor === 'all' || floor === 'All' ? '' : `| Floor ${floor}`}{' '}
                    | Daily Report | {reportDate && reportDate.format('DD MMM YYYY')}
                  </Col>
                  <Col span={4} id={`logo_page${index}`}>
                    <img
                      src="resources/images/circadia-white.png"
                      className="img-fluid"
                      alt="logo"
                      style={{ height: 'auto', width: '20', alignContent: 'right' }}
                    />
                  </Col>
                </Row>
                <Row className={`${style.Timestamp}`} id={`timestamp_page${index}`}>
                  Generated {arr[0].tracker_ts.substring(0, 11)} at{' '}
                  {arr[0].tracker_ts.substring(11, 16)}. Current values: last 24 hr avg. Percentage
                  change: last 72 hr avg.
                </Row>
              </Row>
              <div style={{ paddingTop: 10 }}>
                <Row
                  className={`${style.DailyInfoDiv} ${fullwidthClass}`}
                  id={`DailyInfoDiv_page${index}`}
                >
                  <Row
                    style={{ height: 70 + chunkedArray[index].length * 63 }}
                    className={`${style.DailyInfoCard} ${fullwidthClass}`}
                    id={`DailyInfoCard_page${index}`}
                  >
                    <Row
                      className={` ${style.DailyInfoHeader} ${fullwidthClass}`}
                      id={`DailyInfoHeader_page${index}`}
                    >
                      <Col span={5} id={`roomHeader_page${index}`} className={style.paddingL}>
                        Room
                      </Col>
                      <Col span={5} id={`nameHeader_page${index}`}>
                        Name
                      </Col>
                      <Col span={6} id={`rrHeaderCol_page${index}`}>
                        <Row id={`rrHeader_page${index}`}>Resp Rate (BrPM)</Row>
                      </Col>
                      <Col span={6} id={`timeinbedHeader_page${index}`}>
                        Time in Bed (Hrs)
                      </Col>
                      <Col span={2} id={`flagHeader_page${index}`} style={{ textAlign: 'center' }}>
                        Flag?
                      </Col>
                    </Row>
                    <div style={{ padding: 8 }}>
                      {chunkedArray.length > 0 && (
                        <Row>
                          {arr.map((item, idx) => (
                            <Row
                              id={`ResidentInfoRow${idx}_page${index}`}
                              className={`${style.ResidentAnalytics}`}
                              style={{
                                borderBottomStyle: 'solid',
                                borderBottomWidth: 3,
                                borderBottomColor: '#E2E1DD',
                                padding: 10,
                              }}
                            >
                              <Col
                                span={5}
                                id={`ResidentInfoRow${idx}_room_page${index}`}
                                className={style.paddingL}
                              >
                                {item.room && item.room.length > 11
                                  ? `${item.room.substring(0, 11)}...`
                                  : `${item.room ? item.room : '-'}`}
                              </Col>
                              <Col span={5} id={`ResidentInfoRow${idx}_name_page${index}`}>
                                {item.last_name.length + item.first_name.length > 13 ||
                                item.last_name.length > 13
                                  ? `${item.last_name}, ${item.first_name.substring(0, 1)}`
                                  : `${item.last_name}, ${item.first_name}`}
                              </Col>
                              <Col span={6} id={`ResidentInfoRow${idx}_rr_data_page${index}`}>
                                <Row>
                                  <Col
                                    span={10}
                                    style={{
                                      color: item.rr_outside_range ? 'red' : '',
                                      paddingLeft: !item.rr_avg ? '10px' : '',
                                    }}
                                    id={`ResidentInfoRow${idx}_rr_page${index}`}
                                  >
                                    {!item.rr_avg ? '-' : Math.round(item.rr_avg)}
                                    &nbsp;
                                  </Col>
                                  <Col
                                    id={`ResidentInfoRow${idx}_rrchange_page${index}`}
                                    span={14}
                                    style={{
                                      color: '#908da2',
                                      fontSize: 'x-large',
                                    }}
                                  >
                                    <Row>
                                      <Col
                                        span={7}
                                        style={{
                                          // textAlign: !item.rr_change_hrs_3days ? 'center' : '',
                                          paddingLeft: !item.rr_change_hrs_3days ? '20px' : '',
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: item.rr_change_hrs_3days > 3 ? 'red' : '',
                                          }}
                                        >
                                          {item.rr_change_hrs_3days
                                            ? this.formatAbsoluteValue(item.rr_change_hrs_3days)
                                            : `-`}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={6} id={`ResidentInfoRow${idx}_timeinbed_page${index}`}>
                                <Row>
                                  <Col
                                    span={10}
                                    style={{
                                      color:
                                        item.time_in_bed != null &&
                                        item.time_in_bed.toFixed(1) >= 18
                                          ? 'red'
                                          : '',
                                      paddingLeft: !item.time_in_bed ? '16px' : '',
                                    }}
                                    id={`ResidentInfoRow${idx}_rr_page${index}`}
                                  >
                                    {item.time_in_bed ? Math.round(item.time_in_bed) : '-'} &nbsp;
                                  </Col>
                                  <Col
                                    id={`ResidentInfoRow${idx}_timebedChange_page${index}`}
                                    span={14}
                                    style={{
                                      color: '#908da2',
                                      fontSize: 'x-large',
                                    }}
                                  >
                                    <Row>
                                      <Col
                                        span={7}
                                        style={{
                                          paddingLeft: !item.time_in_bed_change_hrs_3days
                                            ? '20px'
                                            : '',
                                        }}
                                      >
                                        <span>
                                          {item.time_in_bed_change_hrs_3days
                                            ? this.formatAbsoluteValue(
                                                item.time_in_bed_change_hrs_3days,
                                              )
                                            : `-`}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              <Col
                                span={2}
                                id={`ResidentInfoRow${idx}_flag_page${index}`}
                                style={{ textAlign: 'center' }}
                              >
                                <input type="checkbox" className={style.checkBoxStyle} />
                              </Col>
                            </Row>
                          ))}
                        </Row>
                      )}
                    </div>
                  </Row>
                </Row>
              </div>
              <Row
                className={` ${style.footerDiv} ${fullwidthClass}`}
                id={`footerDiv_page${index}`}
              >
                <Col span={22} id={`advisorynote_page${index}`}>
                  This report provides an overview of your practice’s remote patient monitoring
                  activities. It is not an invoice or billing guidance, and is intended only for
                  informational purposes. This is an auto-generated report from the Circadia C100
                  Contactless Monitoring System.
                </Col>
                <Col
                  span={2}
                  id={`pagenumber_page${index}`}
                  style={{
                    color: 'black',
                    fontSize: 'x-large',
                    textAlign: 'right',
                    paddingRight: 5,
                  }}
                >
                  {index + 1} of {chunkedArray.length}
                </Col>
              </Row>
            </div>
          ))}
      </div>
    )
  }
}

export default Report
